"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useEffect, MouseEvent, TouchEvent } from "react";
import { Download, Scissors, Printer, ChevronUp, ChevronDown, Maximize, ZoomIn, ZoomOut, Settings, X } from "lucide-react";
export default function NewsWidget() {
  const $ = _c(132);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      label: "Page 01",
      img: "https://media.dinamani.com/dinamani/2026-02-27/2bygxk4p/rocket.png"
    }, {
      label: "Page 02",
      img: "https://images.unsplash.com/photo-1495020689067-958852a7765e?w=800"
    }, {
      label: "Page 03",
      img: "https://images.unsplash.com/photo-1523995462485-3d171b5c8fa9?w=800"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const pages = t0;
  const [currentPage, setCurrentPage] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [twoPage, setTwoPage] = useState(false);
  const [zoom, setZoom] = useState(1);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 0,
      y: 0
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [offset, setOffset] = useState(t1);
  const [isPanning, setIsPanning] = useState(false);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      x: 0,
      y: 0
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [startPos, setStartPos] = useState(t2);
  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const [, setIsFullscreen] = useState(false);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (!document.fullscreenElement) {
        containerRef.current?.requestFullscreen();
        setIsFullscreen(true);
      } else {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggleFullscreen = t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const esc = e => {
        if (e.key === "Escape") {
          document.exitFullscreen();
          setIsFullscreen(false);
        }
      };
      document.addEventListener("keydown", esc);
      return () => document.removeEventListener("keydown", esc);
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e_0 => {
      setIsPanning(true);
      setStartPos({
        x: e_0.clientX,
        y: e_0.clientY
      });
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const startPan = t6;
  let t7;
  if ($[7] !== isPanning || $[8] !== startPos) {
    t7 = e_1 => {
      if (!isPanning) {
        return;
      }
      setOffset(prev => ({
        x: prev.x + (e_1.clientX - startPos.x),
        y: prev.y + (e_1.clientY - startPos.y)
      }));
      setStartPos({
        x: e_1.clientX,
        y: e_1.clientY
      });
    };
    $[7] = isPanning;
    $[8] = startPos;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const panMove = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsPanning(false);
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const endPan = t8;
  const pinchRef = useRef(null);
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_2 => {
      if (e_2.touches.length === 2) {
        const dx = e_2.touches[0].clientX - e_2.touches[1].clientX;
        const dy = e_2.touches[0].clientY - e_2.touches[1].clientY;
        pinchRef.current = {
          dist: Math.sqrt(dx * dx + dy * dy)
        };
      }
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const onTouchStart = t9;
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e_3 => {
      if (e_3.touches.length === 2 && pinchRef.current) {
        const dx_0 = e_3.touches[0].clientX - e_3.touches[1].clientX;
        const dy_0 = e_3.touches[0].clientY - e_3.touches[1].clientY;
        const newDist = Math.sqrt(dx_0 * dx_0 + dy_0 * dy_0);
        const oldDist = pinchRef.current.dist;
        if (newDist > oldDist) {
          setZoom(_temp);
        } else {
          setZoom(_temp2);
        }
        pinchRef.current.dist = newDist;
      }
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const onTouchMove = t10;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => pinchRef.current = null;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const onTouchEnd = t11;
  const [cropMode, setCropMode] = useState(false);
  const [cropBox, setCropBox] = useState(null);
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      x: 0,
      y: 0
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const [cropStart, setCropStart] = useState(t12);
  const [isDrawingCrop, setIsDrawingCrop] = useState(false);
  const [activeHandle, setActiveHandle] = useState(null);
  const [isMovingCrop, setIsMovingCrop] = useState(false);
  const [cropPreview, setCropPreview] = useState(null);
  let drawCrop;
  let startCrop;
  let stopCropDraw;
  if ($[15] !== activeHandle || $[16] !== cropBox || $[17] !== cropMode || $[18] !== cropStart || $[19] !== isDrawingCrop || $[20] !== isMovingCrop) {
    startCrop = e_4 => {
      if (!cropMode) {
        return;
      }
      const viewer = e_4.currentTarget.getBoundingClientRect();
      const x = e_4.clientX - viewer.left;
      const y = e_4.clientY - viewer.top;
      const handle = getHandleAtPosition(x, y);
      if (handle) {
        setActiveHandle(handle);
        return;
      }
      if (cropBox && isInsideCrop(x, y)) {
        setIsMovingCrop(true);
        setCropStart({
          x,
          y
        });
        return;
      }
      setCropStart({
        x,
        y
      });
      setCropBox({
        x,
        y,
        w: 0,
        h: 0
      });
      setIsDrawingCrop(true);
      setActiveHandle(null);
      setIsMovingCrop(false);
    };
    drawCrop = e_5 => {
      if (!cropMode) {
        return;
      }
      const viewer_0 = e_5.currentTarget.getBoundingClientRect();
      const mx = e_5.clientX - viewer_0.left;
      const my = e_5.clientY - viewer_0.top;
      if (isDrawingCrop) {
        setCropBox({
          x: Math.min(cropStart.x, mx),
          y: Math.min(cropStart.y, my),
          w: Math.abs(mx - cropStart.x),
          h: Math.abs(my - cropStart.y)
        });
      } else {
        if (activeHandle && cropBox) {
          updateResize(mx, my);
        } else {
          if (isMovingCrop && cropBox) {
            const dx_1 = mx - cropStart.x;
            const dy_1 = my - cropStart.y;
            setCropBox({
              ...cropBox,
              x: cropBox.x + dx_1,
              y: cropBox.y + dy_1
            });
            setCropStart({
              x: mx,
              y: my
            });
          }
        }
      }
    };
    let t13;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = () => {
        setIsDrawingCrop(false);
        setActiveHandle(null);
        setIsMovingCrop(false);
      };
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    stopCropDraw = t13;
    const isInsideCrop = (x_0, y_0) => {
      if (!cropBox) {
        return false;
      }
      return x_0 >= cropBox.x && x_0 <= cropBox.x + cropBox.w && y_0 >= cropBox.y && y_0 <= cropBox.y + cropBox.h;
    };
    const getHandleAtPosition = (x_1, y_1) => {
      if (!cropBox) {
        return null;
      }
      const handles = [{
        name: "tl",
        x: cropBox.x,
        y: cropBox.y
      }, {
        name: "tr",
        x: cropBox.x + cropBox.w,
        y: cropBox.y
      }, {
        name: "bl",
        x: cropBox.x,
        y: cropBox.y + cropBox.h
      }, {
        name: "br",
        x: cropBox.x + cropBox.w,
        y: cropBox.y + cropBox.h
      }, {
        name: "t",
        x: cropBox.x + cropBox.w / 2,
        y: cropBox.y
      }, {
        name: "b",
        x: cropBox.x + cropBox.w / 2,
        y: cropBox.y + cropBox.h
      }, {
        name: "l",
        x: cropBox.x,
        y: cropBox.y + cropBox.h / 2
      }, {
        name: "r",
        x: cropBox.x + cropBox.w,
        y: cropBox.y + cropBox.h / 2
      }];
      for (const h of handles) {
        if (Math.abs(x_1 - h.x) < 10 && Math.abs(y_1 - h.y) < 10) {
          return h.name;
        }
      }
      return null;
    };
    const updateResize = (mx_0, my_0) => {
      if (!cropBox || !activeHandle) {
        return;
      }
      let {
        x: x_2,
        y: y_2,
        w,
        h: h_0
      } = cropBox;
      bb123: switch (activeHandle) {
        case "tl":
          {
            w = w + (x_2 - mx_0);
            h_0 = h_0 + (y_2 - my_0);
            x_2 = mx_0;
            y_2 = my_0;
            break bb123;
          }
        case "tr":
          {
            w = mx_0 - x_2;
            h_0 = h_0 + (y_2 - my_0);
            y_2 = my_0;
            break bb123;
          }
        case "bl":
          {
            w = w + (x_2 - mx_0);
            x_2 = mx_0;
            h_0 = my_0 - y_2;
            break bb123;
          }
        case "br":
          {
            w = mx_0 - x_2;
            h_0 = my_0 - y_2;
            break bb123;
          }
        case "t":
          {
            h_0 = h_0 + (y_2 - my_0);
            y_2 = my_0;
            break bb123;
          }
        case "b":
          {
            h_0 = my_0 - y_2;
            break bb123;
          }
        case "l":
          {
            w = w + (x_2 - mx_0);
            x_2 = mx_0;
            break bb123;
          }
        case "r":
          {
            w = mx_0 - x_2;
          }
      }
      if (w > 0 && h_0 > 0) {
        setCropBox({
          x: x_2,
          y: y_2,
          w,
          h: h_0
        });
      }
    };
    $[15] = activeHandle;
    $[16] = cropBox;
    $[17] = cropMode;
    $[18] = cropStart;
    $[19] = isDrawingCrop;
    $[20] = isMovingCrop;
    $[21] = drawCrop;
    $[22] = startCrop;
    $[23] = stopCropDraw;
  } else {
    drawCrop = $[21];
    startCrop = $[22];
    stopCropDraw = $[23];
  }
  let t13;
  if ($[25] !== cropBox) {
    t13 = () => {
      if (!cropBox) {
        return null;
      }
      const handles_0 = [{
        name: "tl",
        class: "top-0 left-0 -mt-1.5 -ml-1.5 cursor-nwse-resize"
      }, {
        name: "tr",
        class: "top-0 right-0 -mt-1.5 -mr-1.5 cursor-nesw-resize"
      }, {
        name: "bl",
        class: "bottom-0 left-0 -mb-1.5 -ml-1.5 cursor-nesw-resize"
      }, {
        name: "br",
        class: "bottom-0 right-0 -mb-1.5 -mr-1.5 cursor-nwse-resize"
      }, {
        name: "t",
        class: "top-0 left-1/2 -mt-1.5 -ml-1.5 cursor-ns-resize"
      }, {
        name: "b",
        class: "bottom-0 left-1/2 -mb-1.5 -ml-1.5 cursor-ns-resize"
      }, {
        name: "l",
        class: "left-0 top-1/2 -ml-1.5 -mt-1.5 cursor-ew-resize"
      }, {
        name: "r",
        class: "right-0 top-1/2 -mr-1.5 -mt-1.5 cursor-ew-resize"
      }];
      return <>{handles_0.map(_temp3)}</>;
    };
    $[25] = cropBox;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const CropHandles = t13;
  let t14;
  if ($[27] !== cropBox || $[28] !== currentPage || $[29] !== offset || $[30] !== zoom) {
    t14 = async () => {
      if (!cropBox || !viewerRef.current) {
        return;
      }
      const imgPath = pages[currentPage].img;
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imgPath;
      await new Promise((resolve, reject) => {
        img.onload = resolve as any;
        img.onerror = reject;
      });
      const viewerRect = viewerRef.current.getBoundingClientRect();
      const imgElement = viewerRef.current.querySelector("img");
      const displayedWidth = imgElement.offsetWidth * zoom;
      const displayedHeight = imgElement.offsetHeight * zoom;
      const scaleX = img.naturalWidth / displayedWidth;
      const scaleY = img.naturalHeight / displayedHeight;
      const centerX = viewerRect.width / 2;
      const centerY = viewerRect.height / 2;
      const imgCenterX = centerX + offset.x;
      const imgCenterY = centerY + offset.y;
      const imgLeft = imgCenterX - displayedWidth / 2;
      const imgTop = imgCenterY - displayedHeight / 2;
      const cropX = (cropBox.x - imgLeft) * scaleX;
      const cropY = (cropBox.y - imgTop) * scaleY;
      const cropW = cropBox.w * scaleX;
      const cropH = cropBox.h * scaleY;
      const canvas = document.createElement("canvas");
      canvas.width = Math.abs(cropW);
      canvas.height = Math.abs(cropH);
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, canvas.width, canvas.height);
      const url = canvas.toDataURL("image/png");
      setCropPreview(url);
    };
    $[27] = cropBox;
    $[28] = currentPage;
    $[29] = offset;
    $[30] = zoom;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const saveCrop = t14;
  let t15;
  if ($[32] !== cropPreview) {
    t15 = () => cropPreview ? <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"><div className="bg-white rounded shadow-xl w-[520px] max-w-full p-6 relative animate-fadeIn"><X onClick={() => setCropPreview(null)} size={22} className="absolute top-4 right-4 cursor-pointer text-gray-600 hover:bg-gray-200 rounded-full p-1" /><h2 className="text-lg font-semibold mb-5">Save this clip</h2><div className="flex justify-center mb-6"><img src={cropPreview} alt="Crop Preview" className="max-h-[260px] border border-DCDCDC shadow-sm rounded" /></div><div className="mb-6"><label className="text-sm font-medium text-gray-600 mr-3">Clip Name</label><input type="text" defaultValue={`Clip ${Date.now()}`} className="border-b border-DCDCDC focus:outline-none px-1 py-1 w-48 text-sm" /></div><button onClick={() => {
          const a = document.createElement("a");
          a.href = cropPreview;
          a.download = "clip.png";
          a.click();
          setCropPreview(null);
        }} className="w-full bg-[#002B64] hover:bg-[#001c44] text-white py-3 rounded text-base font-medium">Save</button></div></div> : null;
    $[32] = cropPreview;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const CropPreviewPopup = t15;
  const [settingsOpen, setSettingsOpen] = useState(false);
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      if (!viewerRef.current) {
        return;
      }
      const viewerWidth = viewerRef.current.offsetWidth;
      const imgElement_0 = viewerRef.current.querySelector("img") as HTMLImageElement;
      if (!imgElement_0) {
        return;
      }
      const imgWidth = imgElement_0.naturalWidth;
      const newZoom = viewerWidth * 0.9 / imgWidth;
      setZoom(newZoom);
      setOffset({
        x: 0,
        y: 0
      });
      setSettingsOpen(false);
    };
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const handleFitWidth = t16;
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => {
      if (!viewerRef.current) {
        return;
      }
      const viewerHeight = viewerRef.current.offsetHeight;
      const imgElement_1 = viewerRef.current.querySelector("img") as HTMLImageElement;
      if (!imgElement_1) {
        return;
      }
      const imgHeight = imgElement_1.naturalHeight;
      const newZoom_0 = viewerHeight * 0.9 / imgHeight;
      setZoom(newZoom_0);
      setOffset({
        x: 0,
        y: 0
      });
      setSettingsOpen(false);
    };
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const handleFitHeight = t17;
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => {
      setZoom(1);
      setOffset({
        x: 0,
        y: 0
      });
      setTwoPage(false);
      setCropMode(false);
      setCropBox(null);
      setSettingsOpen(false);
    };
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const handleReset = t18;
  let SettingsPopup;
  let handleDownload;
  let handlePrint;
  let leftPage;
  let rightPage;
  if ($[37] !== currentPage || $[38] !== settingsOpen || $[39] !== twoPage) {
    handleDownload = () => {
      if (twoPage && rightPage) {
        [leftPage, rightPage].forEach(_temp4);
      } else {
        const link_0 = document.createElement("a");
        link_0.href = leftPage.img;
        link_0.download = `${leftPage.label}.jpg`;
        link_0.click();
      }
    };
    handlePrint = () => {
      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        return;
      }
      let content = `
      <html>
        <head>
          <title>Print - ${leftPage.label}</title>
          <style>
            body { margin: 0; padding: 20px; }
            img { max-width: 100%; height: auto; page-break-after: always; }
          </style>
        </head>
        <body>
          <img src="${leftPage.img}" />
    `;
      if (twoPage && rightPage) {
        content = content + `<img src="${rightPage.img}" />`;
      }
      content = content + "\n        </body>\n      </html>\n    ";
      const blob = new Blob([content], {
        type: "text/html"
      });
      const blobUrl = URL.createObjectURL(blob);
      printWindow.location.href = blobUrl;
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
        URL.revokeObjectURL(blobUrl);
      };
    };
    let t19;
    if ($[45] !== settingsOpen) {
      t19 = () => settingsOpen && <div className="absolute right-2 bottom-20 w-56 bg-white shadow-lg border border-DCDCDC rounded-lg p-2 z-50"><div className="p-3 hover:bg-gray-100 rounded cursor-pointer" onClick={() => {
          setTwoPage(false);
          setZoom(1);
          setSettingsOpen(false);
        }}>Single Page View</div><div className="p-3 hover:bg-gray-100 rounded cursor-pointer" onClick={() => {
          setTwoPage(true);
          setSettingsOpen(false);
        }}>Two Page View</div><div className="p-3 hover:bg-gray-100 rounded cursor-pointer" onClick={handleFitWidth}>Fit Width</div><div className="p-3 hover:bg-gray-100 rounded cursor-pointer" onClick={handleFitHeight}>Fit Height</div><div className="p-3 hover:bg-gray-100 rounded cursor-pointer" onClick={handleReset}>Reset View</div><button onClick={() => setSettingsOpen(false)} className="mt-2 bg-gray-300 hover:bg-gray-400 w-full py-2 rounded">Close</button></div>;
      $[45] = settingsOpen;
      $[46] = t19;
    } else {
      t19 = $[46];
    }
    SettingsPopup = t19;
    leftPage = pages[currentPage];
    rightPage = currentPage + 1 < pages.length ? pages[currentPage + 1] : null;
    $[37] = currentPage;
    $[38] = settingsOpen;
    $[39] = twoPage;
    $[40] = SettingsPopup;
    $[41] = handleDownload;
    $[42] = handlePrint;
    $[43] = leftPage;
    $[44] = rightPage;
  } else {
    SettingsPopup = $[40];
    handleDownload = $[41];
    handlePrint = $[42];
    leftPage = $[43];
    rightPage = $[44];
  }
  let t19;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h2 className="text-24-tamil-700 text-020202 mb-2 md:mb-0">தினமணி - புதுத்தில்லி</h2>;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== dropdownOpen) {
    t20 = () => setDropdownOpen(!dropdownOpen);
    $[48] = dropdownOpen;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const t21 = pages[currentPage];
  let t22;
  if ($[50] !== t21.label) {
    t22 = <span>{t21.label}</span>;
    $[50] = t21.label;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== dropdownOpen) {
    t23 = dropdownOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />;
    $[52] = dropdownOpen;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t20 || $[55] !== t22 || $[56] !== t23) {
    t24 = <div className="flex items-center gap-2 cursor-pointer select-none hover:bg-gray-200 px-3 py-1 rounded" onClick={t20}>{t22}{t23}</div>;
    $[54] = t20;
    $[55] = t22;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== handleDownload) {
    t25 = <Download className="cursor-pointer hover:text-blue-700" size={22} onClick={handleDownload} />;
    $[58] = handleDownload;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  const t26 = `cursor-pointer hover:text-blue-700 ${cropMode ? "text-blue-600" : ""}`;
  let t27;
  if ($[60] !== cropMode) {
    t27 = () => {
      setCropMode(!cropMode);
      setCropBox(null);
    };
    $[60] = cropMode;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t26 || $[63] !== t27) {
    t28 = <Scissors className={t26} onClick={t27} size={22} />;
    $[62] = t26;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== handlePrint) {
    t29 = <Printer className="cursor-pointer hover:text-blue-700" size={22} onClick={handlePrint} />;
    $[65] = handlePrint;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t25 || $[68] !== t28 || $[69] !== t29) {
    t30 = <div className="flex items-center gap-8 text-blue-900 mt-2 md:mt-0 px-4 py-2">{t25}{t28}{t29}</div>;
    $[67] = t25;
    $[68] = t28;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== t24 || $[72] !== t30) {
    t31 = <div className="flex flex-col md:flex-row justify-between items-center px-6 py-4 bg-gray-100">{t19}{t24}{t30}</div>;
    $[71] = t24;
    $[72] = t30;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== currentPage || $[75] !== dropdownOpen) {
    t32 = dropdownOpen && <div className="absolute top-24 left-1/2 transform -translate-x-1/2 bg-white shadow-lg border border-DCDCDC rounded-lg z-40 w-48">{pages.map((p, i) => <div key={i} className={`p-3 hover:bg-gray-100 cursor-pointer ${i === currentPage ? "bg-blue-50" : ""}`} onClick={() => {
        setCurrentPage(i);
        setDropdownOpen(false);
        setCropBox(null);
      }}>{p.label}</div>)}</div>;
    $[74] = currentPage;
    $[75] = dropdownOpen;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  const t33 = `relative min-h-[500px] bg-gradient-to-br from-gray-100 to-gray-200 overflow-hidden flex ${cropMode ? "cursor-crosshair" : "cursor-grab"} ${!cropMode && isPanning ? "cursor-grabbing" : ""}`;
  const t34 = cropMode ? startCrop : startPan;
  const t35 = cropMode ? drawCrop : panMove;
  const t36 = cropMode ? stopCropDraw : endPan;
  const t37 = cropMode ? stopCropDraw : endPan;
  let t38;
  if ($[77] !== CropHandles || $[78] !== cropBox || $[79] !== cropMode || $[80] !== leftPage || $[81] !== offset || $[82] !== twoPage || $[83] !== zoom) {
    t38 = !twoPage && <div className="w-full h-full relative flex items-center justify-center p-4"><img src={leftPage.img} alt={leftPage.label} style={{
        transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain"
      }} className={`select-none ${cropMode ? "pointer-events-none" : ""}`} />{cropMode && cropBox && cropBox.w > 0 && cropBox.h > 0 && <div className="absolute border-2 border-DCDCDC bg-blue-400/20 cursor-move" style={{
        left: cropBox.x,
        top: cropBox.y,
        width: cropBox.w,
        height: cropBox.h,
        pointerEvents: "none"
      }}><div style={{
          pointerEvents: "auto"
        }}><CropHandles /></div></div>}</div>;
    $[77] = CropHandles;
    $[78] = cropBox;
    $[79] = cropMode;
    $[80] = leftPage;
    $[81] = offset;
    $[82] = twoPage;
    $[83] = zoom;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== cropMode || $[86] !== leftPage || $[87] !== offset || $[88] !== rightPage || $[89] !== twoPage || $[90] !== zoom) {
    t39 = twoPage && <><div className="w-1/2 h-full border-r border-DCDCDC relative flex items-center justify-center p-4"><img src={leftPage.img} alt={leftPage.label} style={{
          transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain"
        }} className={`select-none ${cropMode ? "pointer-events-none" : ""}`} /></div>{rightPage && <div className="w-1/2 h-full relative flex items-center justify-center p-4"><img src={rightPage.img} alt={rightPage.label} style={{
          transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain"
        }} className={`select-none ${cropMode ? "pointer-events-none" : ""}`} /></div>}</>;
    $[85] = cropMode;
    $[86] = leftPage;
    $[87] = offset;
    $[88] = rightPage;
    $[89] = twoPage;
    $[90] = zoom;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== t33 || $[93] !== t34 || $[94] !== t35 || $[95] !== t36 || $[96] !== t37 || $[97] !== t38 || $[98] !== t39) {
    t40 = <div ref={viewerRef} className={t33} onMouseDown={t34} onMouseMove={t35} onMouseUp={t36} onMouseLeave={t37}>{t38}{t39}</div>;
    $[92] = t33;
    $[93] = t34;
    $[94] = t35;
    $[95] = t36;
    $[96] = t37;
    $[97] = t38;
    $[98] = t39;
    $[99] = t40;
  } else {
    t40 = $[99];
  }
  let t41;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <ZoomOut className="cursor-pointer hover:text-blue-600" onClick={() => setZoom(_temp5)} size={22} />;
    $[100] = t41;
  } else {
    t41 = $[100];
  }
  let t42;
  if ($[101] !== zoom) {
    t42 = Math.round(zoom * 100);
    $[101] = zoom;
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  let t43;
  if ($[103] !== t42) {
    t43 = <span className="text-sm font-medium">{t42}%</span>;
    $[103] = t42;
    $[104] = t43;
  } else {
    t43 = $[104];
  }
  let t44;
  let t45;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <ZoomIn className="cursor-pointer hover:text-blue-600" onClick={() => setZoom(_temp6)} size={22} />;
    t45 = <Maximize className="cursor-pointer hover:text-blue-600" onClick={toggleFullscreen} size={22} />;
    $[105] = t44;
    $[106] = t45;
  } else {
    t44 = $[105];
    t45 = $[106];
  }
  let t46;
  if ($[107] !== t43) {
    t46 = <div className="flex gap-4 items-center">{t41}{t43}{t44}{t45}</div>;
    $[107] = t43;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== settingsOpen) {
    t47 = <img src="https://media.dinamani.com/dinamani/2026-02-27/occd9qr6/Vector.svg" alt="Settings" className="w-[22px] h-[22px] cursor-pointer hover:opacity-80 transition-opacity" onClick={() => setSettingsOpen(!settingsOpen)} />;
    $[109] = settingsOpen;
    $[110] = t47;
  } else {
    t47 = $[110];
  }
  let t48;
  if ($[111] !== t46 || $[112] !== t47) {
    t48 = <div className="flex justify-between items-center mt-4 px-1">{t46}{t47}</div>;
    $[111] = t46;
    $[112] = t47;
    $[113] = t48;
  } else {
    t48 = $[113];
  }
  let t49;
  if ($[114] !== SettingsPopup) {
    t49 = <SettingsPopup />;
    $[114] = SettingsPopup;
    $[115] = t49;
  } else {
    t49 = $[115];
  }
  let t50;
  if ($[116] !== CropPreviewPopup) {
    t50 = <CropPreviewPopup />;
    $[116] = CropPreviewPopup;
    $[117] = t50;
  } else {
    t50 = $[117];
  }
  let t51;
  if ($[118] !== cropBox || $[119] !== cropMode || $[120] !== saveCrop) {
    t51 = cropMode && <div className="flex justify-end gap-3 mt-4"><button className="px-6 py-2 bg-gray-400 hover:bg-gray-500 text-white font-medium" onClick={() => {
        setCropMode(false);
        setCropBox(null);
      }}>Cancel Crop</button><button className="px-6 py-2 bg-012061 hover:bg-blue-700 text-white font-medium disabled:bg-gray-300 disabled:cursor-not-allowed" onClick={saveCrop} disabled={!cropBox || cropBox.w < 10 || cropBox.h < 10}>Save Crop</button></div>;
    $[118] = cropBox;
    $[119] = cropMode;
    $[120] = saveCrop;
    $[121] = t51;
  } else {
    t51 = $[121];
  }
  let t52;
  if ($[122] !== drawCrop || $[123] !== stopCropDraw || $[124] !== t31 || $[125] !== t32 || $[126] !== t40 || $[127] !== t48 || $[128] !== t49 || $[129] !== t50 || $[130] !== t51) {
    t52 = <div ref={containerRef} className="relative w-full mx-auto p-4 bg-white shadow-xl" onMouseMove={drawCrop} onMouseUp={stopCropDraw} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>{t31}{t32}{t40}{t48}{t49}{t50}{t51}</div>;
    $[122] = drawCrop;
    $[123] = stopCropDraw;
    $[124] = t31;
    $[125] = t32;
    $[126] = t40;
    $[127] = t48;
    $[128] = t49;
    $[129] = t50;
    $[130] = t51;
    $[131] = t52;
  } else {
    t52 = $[131];
  }
  return t52;
}
function _temp6(z_2) {
  return Math.min(5, z_2 + 0.2);
}
function _temp5(z_1) {
  return Math.max(0.5, z_1 - 0.2);
}
function _temp4(page, idx) {
  const link = document.createElement("a");
  link.href = page.img;
  link.download = `${page.label}.jpg`;
  link.click();
}
function _temp3(h_1) {
  return <div key={h_1.name} className={`absolute w-3 h-3 bg-white border-2 border-DCDCDC rounded-sm ${h_1.class}`} />;
}
function _temp2(z_0) {
  return Math.max(0.5, z_0 - 0.04);
}
function _temp(z) {
  return Math.min(5, z + 0.04);
}